<template>
  <div class="modal sign-modal reg-modal">
    <div class="overlay" @click="$parent.closeSignUp" />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <button class="close" @click="$parent.closeSignUp">
              <div class="desc smallest">{{ $t("Close") }}</div>
              <img class="img" src="./../img/close.svg" />
            </button>

            <div class="left">
              <div class="top-text">
                <div class="title big title-main">
                  {{ $t("Create account") }}
                </div>
              </div>
              <div class="bottom-text">
                <div class="title">{{ $t("Already have an account?") }}</div>
                <a class="button bordered" @click="$parent.openSignIn">
                  <span>{{ $t("Log in") }}</span>
                </a>

                <img class="traveler" src="./../img/traveler.webp" />
              </div>
            </div>
            <div class="right">
              <div class="form-fields register-content">
                <div class="form-fields-wrapper">
                  <label>
                    <div class="desc">{{ $t("First name") }}</div>
                    <input
                      v-model="name"
                      type="text" @input="filterInput($event, 'name')"
                      :placeholder="$t('First name')"
                    />
                  </label>
                  <label>
                    <div class="desc">{{ $t("Last Name") }}</div>
                    <input
                      v-model="surname"
                      type="text" @input="filterInput($event, 'surname')"
                      :placeholder="$t('Last Name')"
                    />
                  </label>
                  <label>
                    <div class="desc">{{ $t("Email") }}</div>
                    <input
                      v-model="email"
                      type="email" @input="filterInput($event, 'email')"
                      :placeholder="$t('Email')"
                    />
                  </label>
                  <label>
                    <div class="desc">{{ $t("Password") }}</div>
                    <input
                      v-model="pass"
                      type="password"
                      :placeholder="$t('Password')"
                    />
                  </label>
                  <label>
                    <div class="desc">{{ $t("Confirm Password") }}</div>
                    <input
                      v-model="passConfirm"
                      type="password"
                      :placeholder="$t('Confirm Password')"
                    />
                  </label>
                  <div class="cta-container">
                    <div class="chekbox-container">
                      <label class="chekbox-label">
                        <div class="chekbox-label-wrapper">
                          <input v-model="terms" type="checkbox" name="terms" />
                          <div class="checkbox"></div>
                          <span class="desc">{{ $t("I agree with") }} </span>
                          <a
                            class="desc orange"
                            @click="$parent.goToPage('privacy')"
                          >
                            {{ $t("privacy policy") }}
                          </a>
                          <span class="desc"> {{ $t("and") }} </span>
                          <a
                            class="desc orange"
                            @click="$parent.goToPage('terms')"
                          >
                            {{ $t("terms and conditions") }}
                          </a>
                        </div>
                      </label>
                    </div>
                    <button
                      :class="[
                        'button blue small',
                        { disabled: !requiredRegisterFieldsAreFilled },
                      ]"
                      @click="submitRegister"
                    >
                      <span>{{ $t("Sign up") }}</span>
                    </button>
                  </div>
                  <transition name="slide">
                    <div v-if="$parent.error" class="error-desc desc red">
                      {{ $parent.error }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Registration",
  props: [],
  data: function () {
    return {
      email: "",
      pass: "",
      name: "",
      surname: "",
      phone: "",
      passConfirm: "",
      terms: false,
    };
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.email &&
        this.pass &&
        this.passConfirm &&
        this.terms
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  mounted() {},
  methods: {
    filterInput(e, field) {
       let value = e.target.value;
      if (field === "email") {
        value = value.replace(/[^a-zA-Z0-9@._%+-]/g, "");
        value = value.replace(/\s+/g, "");
      } else {
        value = value.replace(/[^a-zA-Z0-9\s'-]/g, '');
      }
       value = value.replace(/\s+/g, ' ').trimStart();
       this[field] = value;
    },
    allowOnlyNumbers() {
      this.phone = this.phone.replace(/[^0-9.,]/g, "");
      const parts = this.phone.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.phone =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    closeSignUpModal() {
      this.$emit("closeSignIn");
    },
    openSignInModal() {
      this.$emit("openSignIn");
    },
    submitRegister() {
      let regData = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        password: this.pass,
        passConfirm: this.passConfirm,
      };
      this.$emit("registration", regData);
    },
  },
};
</script>
